<div class="ab-input-group w-100">
  <div class="ab-input-group__field d-flex">
    <mat-form-field class="col__ mt-0 mb-0">
      <mat-label>{{fieldNameLabels.firstName}}</mat-label>
      <input matInput
             autocomplete="off"
             type="text"
             [ngModel]="firstName"
             (ngModelChange)="modelChanged('firstName', $event)">
      <button *ngIf="firstName"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="modelChanged('firstName', null)">
        <mat-icon fontSet="fal"
                  fontIcon="fa-times"></mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>

<div class="ab-input-group mt-0075 w-100">
  <div class="ab-input-group__field d-flex">
    <mat-form-field class="col__ mt-0 mb-0">
      <mat-label>{{fieldNameLabels.middleName}}</mat-label>
      <input matInput
             type="text"
             autocomplete="off"
             [ngModel]="middleName"
             (ngModelChange)="modelChanged('middleName', $event)"
             [disabled]="middleNameNullChecked">
      <button *ngIf="middleName"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="modelChanged('middleName', null)">
        <mat-icon fontSet="fal"
                  fontIcon="fa-times"></mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="ab-input-group__append">
    <div class="ab-input-group__text">
      <mat-checkbox class="name-field-row__checkbox txt-fw-400 nowrap"
                    [(ngModel)]="middleNameNullChecked"
                    #middleNameCheckbox
                    (change)="onNullNameCheckboxChanged(middleNameCheckbox.checked, 'middleName')">
        <span class="txt-fw-400 nowrap">Is blank</span>
        <button mat-icon-button
                #middleNameNullTooltip="matTooltip"
                (click)="middleNameNullTooltip.toggle()"
                [matTooltip]="nameNullTooltipText('Middle Name')"
                type="button"
                class="w-auto h-auto lh-normal d-none d-inline-block--ps">
          <mat-icon fontSet="fal fa-fw"
                    fontIcon="fa-info-circle"></mat-icon>
        </button>
      </mat-checkbox>
    </div>
  </div>
</div>

<div class="ab-input-group mt-0075 w-100">
  <div class="ab-input-group__field d-flex">
    <mat-form-field class="col__ mt-0 mb-0">
      <mat-label>{{fieldNameLabels.lastName}}</mat-label>
      <input matInput
             autocomplete="off"
             type="text"
             [ngModel]="lastName"
             (ngModelChange)="modelChanged('lastName', $event)"
             [disabled]="lastNameNullChecked">
      <button *ngIf="lastName"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="modelChanged('lastName', null)">
        <mat-icon fontSet="fal"
                  fontIcon="fa-times"></mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="ab-input-group__append">
    <div class="ab-input-group__text">
      <mat-checkbox class="name-field-row__checkbox txt-fw-400 nowrap"
                    [(ngModel)]="lastNameNullChecked"
                    #lastNameCheckbox
                    (change)="onNullNameCheckboxChanged(lastNameCheckbox.checked, 'lastName')">
        <span class="txt-fw-400 nowrap">Is blank</span>
        <button mat-icon-button
                #lastNameNullTooltip="matTooltip"
                (click)="lastNameNullTooltip.toggle()"
                [matTooltip]="nameNullTooltipText('Last Name')"
                type="button"
                class="w-auto h-auto lh-normal d-none d-inline-block--ps">
          <mat-icon fontSet="fal fa-fw"
                    fontIcon="fa-info-circle"></mat-icon>
        </button>
      </mat-checkbox>
    </div>
  </div>
</div>

<div class="ab-input-group mt-0075 w-100">
  <div class="ab-input-group__field d-flex">
    <mat-form-field class="col__ mt-0 mb-0">
      <mat-label>{{fieldNameLabels.nickname}}</mat-label>
      <input matInput
             autocomplete="off"
             type="text"
             [ngModel]="nickname"
             (ngModelChange)="modelChanged('nickname', $event)"
             [disabled]="nicknameNullChecked">
      <button *ngIf="nickname"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="modelChanged('nickname', null)">
        <mat-icon fontSet="fal"
                  fontIcon="fa-times"></mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="ab-input-group__append">
    <div class="ab-input-group__text">
      <mat-checkbox class="name-field-row__checkbox txt-fw-400 nowrap"
                    [(ngModel)]="nicknameNullChecked"
                    #nicknameCheckbox
                    (change)="onNullNameCheckboxChanged(nicknameCheckbox.checked, 'nickname')">
        <span class="txt-fw-400 nowrap">Is blank</span>
        <button mat-icon-button
                #nicknameNullTooltip="matTooltip"
                (click)="nicknameNullTooltip.toggle()"
                [matTooltip]="nameNullTooltipText('Preferred Name')"
                type="button"
                class="w-auto h-auto lh-normal d-none d-inline-block--ps">
          <mat-icon fontSet="fal fa-fw"
                    fontIcon="fa-info-circle"></mat-icon>
        </button>
      </mat-checkbox>
    </div>
  </div>
</div>

<div class="ab-input-group mt-0075 w-100">
  <div class="ab-input-group__field d-flex">
    <mat-form-field class="col__ mt-0 mb-0">
      <mat-label>{{fieldNameLabels.suffix}}</mat-label>
      <input matInput
             autocomplete="off"
             type="text"
             [ngModel]="suffix"
             (ngModelChange)="modelChanged('suffix', $event)"
             [disabled]="suffixNullChecked">
      <button *ngIf="suffix"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="modelChanged('suffix', null)">
        <mat-icon fontSet="fal"
                  fontIcon="fa-times"></mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="ab-input-group__append">
    <div class="ab-input-group__text">
      <mat-checkbox class="name-field-row__checkbox txt-fw-400 nowrap"
                    [(ngModel)]="suffixNullChecked"
                    #suffixCheckbox
                    (change)="onNullNameCheckboxChanged(suffixCheckbox.checked, 'suffix')">
        <span class="txt-fw-400 nowrap">Is blank</span>
        <button mat-icon-button
                #suffixNullTooltip="matTooltip"
                (click)="suffixNullTooltip.toggle()"
                [matTooltip]="nameNullTooltipText('Suffix')"
                type="button"
                class="w-auto h-auto lh-normal d-none d-inline-block--ps">
          <mat-icon fontSet="fal fa-fw"
                    fontIcon="fa-info-circle"></mat-icon>
        </button>
      </mat-checkbox>
    </div>
  </div>
</div>
